var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"polygon_arrays"},[(!_vm.errors)?_c('div',{ref:"map",staticClass:"google_maps",style:({
        height: _vm.height,
    })}):_c('div',{staticClass:"ui error message"},[_c('div',{staticClass:"header"},[_vm._v("\n            "+_vm._s(_vm.errors)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }